import './vaadin-featureflags.js';

import '../index';

import './theme-my-hilla-app.global.generated.js';
import { applyTheme } from './theme.js';
applyTheme(document);
